/**
 * Conservative JS indent for the job editor.
 * Does not reflow lines; skips braces inside strings and comments.
 */

function tokenizeLine(line, startInBlockComment = false) {
  let inSingle = false;
  let inDouble = false;
  let inTemplate = false;
  let inLineComment = false;
  let inBlockComment = startInBlockComment;
  let net = 0;
  let leadingClosers = 0;
  let seenCode = false;

  for (let i = 0; i < line.length; i += 1) {
    const ch = line[i];
    const next = line[i + 1];
    if (inLineComment) break;
    if (inBlockComment) {
      if (ch === "*" && next === "/") {
        inBlockComment = false;
        i += 1;
      }
      continue;
    }
    if (inSingle) {
      if (ch === "\\") {
        i += 1;
        continue;
      }
      if (ch === "'") inSingle = false;
      continue;
    }
    if (inDouble) {
      if (ch === "\\") {
        i += 1;
        continue;
      }
      if (ch === '"') inDouble = false;
      continue;
    }
    if (inTemplate) {
      if (ch === "\\") {
        i += 1;
        continue;
      }
      if (ch === "`") inTemplate = false;
      continue;
    }
    if (ch === "/" && next === "/") {
      inLineComment = true;
      break;
    }
    if (ch === "/" && next === "*") {
      inBlockComment = true;
      i += 1;
      continue;
    }
    if (ch === "'") {
      inSingle = true;
      seenCode = true;
      continue;
    }
    if (ch === '"') {
      inDouble = true;
      seenCode = true;
      continue;
    }
    if (ch === "`") {
      inTemplate = true;
      seenCode = true;
      continue;
    }
    if (ch === "{" || ch === "(" || ch === "[") {
      net += 1;
      seenCode = true;
    } else if (ch === "}" || ch === ")" || ch === "]") {
      net -= 1;
      if (!seenCode) leadingClosers += 1;
      seenCode = true;
    } else if (!/\s/.test(ch)) {
      seenCode = true;
    }
  }
  return { net, leadingClosers, inBlockComment };
}

export function prettyJs(source, indentUnit = "  ") {
  const text = String(source || "").replace(/\r\n/g, "\n");
  const lines = text.split("\n");
  let depth = 0;
  let inBlockComment = false;
  const out = [];
  for (const raw of lines) {
    const trimmed = raw.trim();
    if (!trimmed) {
      out.push("");
      continue;
    }
    const { net, leadingClosers, inBlockComment: nextBlock } = tokenizeLine(
      trimmed,
      inBlockComment,
    );
    inBlockComment = nextBlock;
    depth = Math.max(0, depth - leadingClosers);
    out.push(indentUnit.repeat(depth) + trimmed);
    depth = Math.max(0, depth + net + leadingClosers);
  }
  const pretty = out.join("\n").replace(/\n{3,}/g, "\n\n");
  return pretty.endsWith("\n") ? pretty : `${pretty}\n`;
}
